/**
 * Disclaimer: These indicator descriptions were generated by the AI assistant Carl, created by Nebula.
 * They are intended to provide generic examples for describing the overall score of a backstage entity.
 * The descriptions have been added the goal of helping to identify areas for improvement or recognition of strong performance.
 */

export const POOR_INDICATOR_TITLE = 'Significant issues';

export const POOR_INDICATOR_DESCRIPTION =
  'There are significant issues and underperformance that require immediate attention and corrective action.';

export const NEEDS_IMPROVEMENT_TITLE = 'Needs Improvement';

export const NEEDS_IMPROVEMENT_INDICATOR_DESCRIPTION =
  'There are notable areas of concern that need to be addressed to improve performance and reduce waste.';

export const SATISFACTORY_INDICATOR_TITLE = 'Can do better';

export const SATISFACTORY_INDICATOR_DESCRIPTION =
  'The overall score is at an acceptable level, indicating good performance but with room for improvements.';

export const GOOD_INDICATOR_TITLE = 'Good!';

export const GOOD_INDICATOR_DESCRIPTION =
  'The overall score is at a good level, but there are still opportunities to optimize performance and enhance efficiency.';

export const EXCELLENT_INDICATOR_TITLE = 'Excellent !';

export const EXCELLENT_INDICATOR_DESCRIPTION =
  'Exceptional performance is demonstrated with highly efficient processes, setting a benchmark for best practices.';
